import React from 'react';
import { clsx } from 'clsx';
import { PROVIDER_CATEGORY_STYLES } from './intelVisualConfig';

type Props = {
    category: string;
    label: string;
    className?: string;
};

export const CategoryBadge: React.FC<Props> = ({ category, label, className }) => {
    const style = PROVIDER_CATEGORY_STYLES[category] ?? {
        border: 'border-border',
        text: 'text-muted-foreground',
        bg: 'bg-muted/50',
    };

    return (
        <span
            className={clsx(
                'inline-flex items-center rounded-md border px-1.5 py-0.5 text-[10px] font-medium',
                style.border,
                style.text,
                style.bg,
                className,
            )}
        >
            {label}
        </span>
    );
};
